export default __webpack_public_path__ + "static/media/Rectangle 51 (1).8bd5674a.png";